import type { Questionnaire } from '@/contexts/questionnaires/Questionnaire.interfaces'

export const checkLabel = (
  label_en: string,
  label_fr: string,
  type: string,
  questionnaire: Questionnaire
): boolean | undefined => {
  if (type === 'ITEM') {
    if ((label_en !== null && label_en.trim().length !== 0) || (label_fr !== null && label_fr.trim().length !== 0)) {
      return true
    } else if (questionnaire.sections && questionnaire.sections.length > 0) {
      for (const section of questionnaire.sections) {
        if (section.questions && section.questions.length > 0) {
          for (const question of section.questions) {
            if (question.items && question.items.length > 0) {
              question.items.forEach((val, index) => {
                if (
                  !(val.label_en !== null && val.label_en.trim().length !== 0) &&
                  !(val.label_fr !== null && val.label_fr.trim().length !== 0)
                ) {
                  question.items.splice(index, 1)
                }
              })
            }
          }
        }
      }
    }
  } else if (
    (label_en !== null && label_en.trim().length !== 0) ||
    (label_fr !== null && label_fr.trim().length !== 0)
  ) {
    return true
  }
}

export const checkIdentifier = (
  identifier: string,
  type: string,
  questionnaire: Questionnaire,
  item_id: number
): boolean => {
  const reg = new RegExp(/^[a-zA-Z0-9_.\-]{1,10}$/g)
  if (!reg.test(identifier)) {
    return false
  }

  if (identifier && type && questionnaire) {
    if (type === 'SECTION') {
      if (questionnaire.sections && questionnaire.sections.length > 0) {
        for (const section of questionnaire.sections) {
          if (section.id === item_id) {
            continue
          }
          if (section.identifier.toString() === identifier.toString()) {
            return false
          }
        }
      }
      return true
    } else if (type === 'QUESTION') {
      if (questionnaire.sections && questionnaire.sections.length > 0) {
        for (const section of questionnaire.sections) {
          if (section.questions && section.questions.length > 0) {
            for (const question of section.questions) {
              if (question.id === item_id) {
                continue
              }
              if (question.identifier.toString() === identifier.toString()) {
                return false
              }
            }
          }
        }
      }
      return true
    }
  }
  return false
}

export const generateIdentifier = (type: string, questionnaire: Questionnaire): string | undefined => {
  if (type && questionnaire) {
    if (type === 'SECTION') {
      const identifiers_array = [{ id: -1, val: 0, prefix: 'S' }]
      if (questionnaire.sections && questionnaire.sections.length > 0) {
        for (const section of questionnaire.sections) {
          let numbers: number[] = []
          let prefix: string[] = []
          const identifier: string = section.identifier
          const numberMatches = identifier.match(/[\d\.]+/g)
          if (numberMatches) {
            numbers = numberMatches.map((i) => parseInt(i))
          }
          const prefixMatches = identifier.match(/[\D\.]+/g)
          if (prefixMatches) {
            prefix = prefixMatches
          }
          const new_identifier = {
            id: section.id,
            val: numbers.length > 0 ? Math.max(...numbers) : 0,
            prefix: prefix[0] ? prefix[0] : '',
          }
          identifiers_array.push(new_identifier)
        }
      }
      const max_identifier = Math.max(...identifiers_array.map((id) => id.val)) + 1
      const max_prefix = identifiers_array.reduce((a, obj) => (a.val > obj.val ? a : obj)).prefix
      return max_prefix + max_identifier
    } else if (type === 'QUESTION') {
      const identifiers_array = [{ id: -1, val: 0, prefix: 'Q' }]
      if (questionnaire.sections && questionnaire.sections.length > 0) {
        for (const section of questionnaire.sections) {
          if (section.questions && section.questions.length > 0) {
            for (const question of section.questions) {
              const identifier = question.identifier
              let numbers: number[] = []
              let prefix: string[] = []
              const numberMatches = identifier.match(/[\d\.]+/g)
              if (numberMatches) {
                numbers = numberMatches.map((i) => parseInt(i))
              }
              const prefixMatches = identifier.match(/[\D\.]+/g)
              if (prefixMatches) {
                prefix = prefixMatches
              }

              const new_identifier = {
                id: question.id,
                val: numbers.length > 0 ? Math.max(...numbers) : 0,
                prefix: prefix[0] ? prefix[0] : '',
              }
              identifiers_array.push(new_identifier)
            }
          }
        }
      }
      const max_identifier = Math.max(...identifiers_array.map((id) => id.val)) + 1
      const max_prefix = identifiers_array.reduce((a, obj) => (a.val > obj.val ? a : obj)).prefix
      return max_prefix + max_identifier
    }
  }
}
